<script setup lang="ts">
import { NxtAddress } from '@future-harry/nxt-styles';
import { Address } from '@future-harry/nxt-vue-library';
import { useAddressAutocomplete } from '@/core/composables/useAddressAutocomplete';

const modelValue = defineModel<Partial<Address> | undefined>();
defineProps<{ name: string; errors?: Record<string, string> }>();
const { placesApiKey, placesIndex, searchCities, getAddress } = useAddressAutocomplete();
</script>

<template>
   <NxtAddress
      v-model="modelValue"
      :places-api-key="placesApiKey"
      :places-index="placesIndex"
      :name="name"
      :search-cities="searchCities"
      :useV2="true"
      :get-address="getAddress"
      :errors="errors"
      :translations="{
         address: {
            street: $t('generic.addresses.street'),
            houseNumber: $t('generic.addresses.number'),
            city: $t('generic.addresses.city'),
            box: $t('generic.addresses.box'),
            useLocation: $t('generic.addresses.use-location'),
         },
         actions: {
            delete: $t('actions.delete', 2),
            searchCities: $t('actions.search'),
            searchPlaces: $t('actions.search'),
         },
      }"
   />
</template>

<style lang="scss">
// hide "Zoeken" label as it does nothing and confuses users
.nxt-select-option:not(.-selectable):not(.highlighted) {
   // display: none;
}
</style>
